module.exports = __webpack_public_path__ + "img/saudi-arabia.ec114d74.png";